export function initFRPage(): void {
  const tabs = document.querySelectorAll<HTMLLIElement>(".f-item");
  const panes = document.querySelectorAll<HTMLElement>(".pane");

  function activate(targetId: string | undefined): void {
    if (!targetId) {
      return;
    }

    tabs.forEach((t) => t.classList.toggle("active", t.dataset.target === targetId));

    panes.forEach((p) =>
      p.classList.toggle("active", `#${p.id}` === `#${targetId.replace(/^#?/, "")}`)
    );
  }

  tabs.forEach((t) => {
    const targetId = t.dataset.target;
    if (!targetId) {
      return;
    }

    t.addEventListener("click", () => activate(targetId));

    t.setAttribute("tabindex", "0");
    t.setAttribute("role", "tab");
    t.setAttribute("aria-controls", targetId.replace("#", ""));
  });

  const heroCard = document.querySelector<HTMLElement>(".hero-card");
  if (heroCard) {
    const video = heroCard.querySelector<HTMLVideoElement>("video");
    const overlay = heroCard.querySelector<HTMLElement>(".elementor-custom-embed-image-overlay");
    const playBtn = heroCard.querySelector<HTMLElement>(".elementor-custom-embed-play") || overlay;

    const hideOverlay = (): void => {
      if (overlay) {
        overlay.classList.add("is-hidden");
      }
    };

    const showOverlay = (): void => {
      if (overlay) {
        overlay.classList.remove("is-hidden");
      }
    };

    const startPlayback = (): void => {
      if (!video) {
        return;
      }
      hideOverlay();

      video.setAttribute("controls", "");
      const p = video.play();
      if (p && typeof p.catch === "function") {
        p.catch(() => {});
      }
    };

    if (playBtn) {
      playBtn.addEventListener("click", startPlayback);
      playBtn.setAttribute("tabindex", "0");
    }

    if (video) {
      video.addEventListener("play", hideOverlay);
      video.addEventListener("pause", showOverlay);
      video.addEventListener("ended", showOverlay);
    }
  }
}
